import { CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { CustomInput } from 'src/consumer/components/helperComponents'
import {
  ConfirmationModalPrimaryButton,
  ConfirmationModalSecondaryButton,
} from 'src/consumer/components/helperComponentsStyles'

export default function ActivityFeatureBase({
  formData,
  setFormData,
  handleChangeFeature,
  handleSubmit,
  onClose,
  saving,
  children,
}) {
  return (
    <>
      <DialogTitle>Create Rest</DialogTitle>
      <DialogContent>
        <CustomInput
          id="title"
          value={formData?.title}
          onChange={handleChangeFeature}
          label="Title"
        />
        <CustomInput
          id="description"
          value={formData?.description}
          onChange={handleChangeFeature}
          label="Description"
        />
        {children}
      </DialogContent>
      <DialogActions>
        <ConfirmationModalSecondaryButton disabled={saving} onClick={onClose}>
          Close
        </ConfirmationModalSecondaryButton>
        <ConfirmationModalPrimaryButton
          style={{ position: 'relative' }}
          disabled={saving}
          onClick={handleSubmit}
        >
          Save
          {saving && (
            <CircularProgress sx={{ position: 'absolute', width: '25px !important', height: '25px !important', color: '#fff' }} />
          )}
        </ConfirmationModalPrimaryButton>
      </DialogActions>
    </>
  )
}
